import React from 'react'
import style from './Login.module.css'
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '../../components';

const Login = () => {

    const navigate = useNavigate();

    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [alert, setAlert] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    const [recuperarContrasena, setRecuperarContrasena] = useState(false)

    const goNext = () => {
        navigate('/admin');
    }

    return (
        <div className={style.container}>
            {
                recuperarContrasena ? 
                <>
                    <input className={style.input} value={user} type="email" onInput={e => setUser(e.target.value)} placeholder='Ingresa tu email'></input>
                    <span className={style.passwordMessage} data-disabled={showMessage}>Un email fue enviado a la casilla correspondiente.</span>
                    <div className={style.button}>
                        <Button text='Recuperar contraseña' onClick={() => {setShowMessage(true)}}/>
                    </div>
                    <span className={style.recuperarContrasena} onClick={() => {setRecuperarContrasena(false)}}>Volver al login</span>
                </>
                :
                <>
                    <input className={style.input} value={user} onInput={e => setUser(e.target.value)} placeholder='Usuario'></input>
                    <input className={style.input} type="password" value={password} onInput={e => setPassword(e.target.value)} placeholder='Contraseña'></input>
                    <span className={style.alertName} data-disabled={alert}>Los datos ingresados son incorrectos</span>
                    <span onClick={() => {setAlert(true)}}>show alert</span>
                    <div className={style.button}>
                        <Button text='Inciar Sesión' onClick={goNext}/>
                    </div>
                    <span className={style.recuperarContrasena} onClick={() => {setRecuperarContrasena(true)}}>Recuperar contraseña</span>
                </>
            }

        </div>
    )
}

export default Login